export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          联系我们
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-[480px] mx-auto">
          有想看的影片？欢迎向我们反馈和投稿
        </p>

        <div className="max-w-[720px] mx-auto">
          <div className="bg-background-50 border border-background-200/70 rounded-2xl p-6 md:p-8">
            <div className="flex flex-col lg:flex-row gap-8">
              <div className="flex-1 space-y-5">
                <div>
                  <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2">投稿与反馈</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    如果您有优质的影视资源推荐、影片投稿需求，或者在使用过程中遇到任何问题，欢迎通过以下方式与我们取得联系。我们会在第一时间处理您的反馈，持续优化观影体验。
                  </p>
                </div>
                <div className="space-y-3">
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className="ri-mail-line"></i>
                    </div>
                    <div>
                      <div className="text-xs text-foreground-400">电子邮箱</div>
                      <div className="text-sm font-medium text-foreground-800">contact@taohua-cinema.com</div>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                      <i className="ri-wechat-line"></i>
                    </div>
                    <div>
                      <div className="text-xs text-foreground-400">微信公众号</div>
                      <div className="text-sm font-medium text-foreground-800">桃花影院在线</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex-1">
                <div className="space-y-3">
                  <div className="flex items-center gap-3 p-3 bg-background-100 rounded-xl">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                      <i className="ri-movie-line text-lg"></i>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-800">影片投稿</div>
                      <div className="text-xs text-foreground-500">推荐优质影视资源给更多观众</div>
                    </div>
                  </div>
                  <div className="flex items-center gap-3 p-3 bg-background-100 rounded-xl">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className="ri-bug-line text-lg"></i>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-800">问题反馈</div>
                      <div className="text-xs text-foreground-500">播放问题、页面错误及时告知我们</div>
                    </div>
                  </div>
                  <div className="flex items-center gap-3 p-3 bg-background-100 rounded-xl">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-200 text-secondary-600 flex-shrink-0">
                      <i className="ri-hand-heart-line text-lg"></i>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-800">商务合作</div>
                      <div className="text-xs text-foreground-500">广告投放与品牌合作咨询</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}